import React, { useState } from "react";
import "./UploadButton.css";


const PRESET_SAMPLES = [
  { label: "🔴  Emergency",       uri: "s3://retryawstranscribe/audio_uploads/15bbeb6f-6e28-4e5d-b244-cddcd7f26e8e_1751783306.mp3" },
  { label: "🟠  Attention",       uri: "s3://retryawstranscribe/audio_uploads/ecc0819a-df7c-4fee-98f8-77aa950afc08_1751783396.mp3" },
  { label: "🚨  Security breach", uri: "s3://retryawstranscribe/audio_uploads/4483d10d-04d6-49a9-96df-bf2fe0d33a80_1751783481.mp3" },
];

const UploadButton = ({ onSuccess }) => {
  const [file,        setFile]        = useState(null);
  const [uploading,   setUploading]   = useState(false);
  const [error,       setError]       = useState(null);
  const [presetIdx,   setPresetIdx]   = useState("");       

  
  const handleChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type !== "audio/mpeg") {
      setError("Only .mp3 files are allowed.");
      setFile(null);
      return;
    }
    setFile(selectedFile);
    setError(null);
    setPresetIdx("");                                        
  };

  const handleUpload = async () => {
    if (!file) {
      setError("Please select an .mp3 file.");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);

    setUploading(true);
    setError(null);

    try {
      const resp = await fetch(`${process.env.REACT_APP_API_BASE_URL}/upload-audio`, {
        method: "POST",
        body:   formData,
      });
      if (!resp.ok) throw new Error(await resp.text());
      const data = await resp.json();
      onSuccess(data.s3_uri);
    } catch (err) {
      console.error("Upload Error:", err);
      setError("❌ Upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  const handlePresetSelect = (e) => {
    const idx = e.target.value;
    setPresetIdx(idx);
    if (idx !== "") {
      
      onSuccess(PRESET_SAMPLES[idx].uri);
      setFile(null);
      setError(null);
    }
  };

  return (
    <div className="upload-container">
    
      <input
        type="file"
        accept="audio/mp3"
        onChange={handleChange}
        disabled={uploading}
        aria-label="Upload .mp3 file"
      />
      <button onClick={handleUpload} disabled={uploading || !file}>
        {uploading ? "Uploading…" : "Upload"}
      </button>

     
      <div className="sample-select-wrapper">
        <label htmlFor="sampleSelect"><small>or pick a sample ▶︎</small></label>
        <select
          id="sampleSelect"
          value={presetIdx}
          onChange={handlePresetSelect}
          disabled={uploading}
        >
          <option value="">— Select —</option>
          {PRESET_SAMPLES.map((s, i) => (
            <option key={i} value={i}>{s.label}</option>
          ))}
        </select>
      </div>

      {error && <p className="error-text">{error}</p>}
    </div>
  );
};

export default UploadButton;
